import bs58 from 'bs58'

export class ConversionsService {
    // Converte string hexadecimal para Uint8Array
    private hexToUint8Array(hex) {
        const bytes = new Uint8Array(hex.length / 2)
        for (let i = 0; i < hex.length; i += 2) {
            bytes[i / 2] = parseInt(hex.substr(i, 2), 16)
        }
        return bytes
    }

    // Converte Uint8Array para string hexadecimal
    private uint8ArrayToHex(bytes) {
        return [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('')
    }

    uuidToBase58(uuid) {
        const hex = uuid.replace(/-/g, '') // Remove os hífens
        const bytes = this.hexToUint8Array(hex) // Converte para Uint8Array
        return bs58.encode(bytes) // Codifica em Base58
    }

    // Converte Base58 de volta para UUID
    base58ToUuid(short) {
        const bytes = bs58.decode(short) // Decodifica Base58 para bytes
        const hex = this.uint8ArrayToHex(bytes).padStart(32, '0') // Converte de volta para string hexadecimal
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}` // Formata como UUID
    }
}
